"use client";
import { createContext, useContext, useState } from "react";

export const TrainerContext = createContext({
  trainerFilters: {
    districtId: 0,
    occupationId: 0,
  },
  setTrainerFilters: (tr: any) => {},
});

export const TrainerProvider = ({ children }: any) => {
  const [trainerFilters, setTrainerFilters] = useState({} as any);

  const value = {
    trainerFilters,
    setTrainerFilters,
  };

  return (
    <TrainerContext.Provider value={value}>{children}</TrainerContext.Provider>
  );
};

export const useTrainerContext = () => {
  return useContext(TrainerContext);
};
